import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { BanksApi } from 'api/BanksApi';
import { getFiBankStore } from 'stores/FiBankStore';
import { TRANSACTION_CODES_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useTransactionCodes({
  shouldNotifyOnChange = true
}: { shouldNotifyOnChange?: boolean } = {}) {
  const banksApi = new BanksApi();
  const bankStore = getFiBankStore();
  const { userBankId } = useUser();

  const { data: transactionCodes, isLoading: isTransactionCodes } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [TRANSACTION_CODES_KEY, userBankId],
    queryFn: () => banksApi.getBankInternalCodes(userBankId),
    ...(!shouldNotifyOnChange && { notifyOnChangeProps: [] })
  });

  useEffect(() => {
    if (transactionCodes && Object.keys(transactionCodes).length > 0) {
      bankStore.setTransactionCodes(transactionCodes);
    }
  }, [transactionCodes]);

  return { transactionCodes, isTransactionCodes };
}
